'use strict';

import type { PropsWithChildren } from 'react';
import { ChakraProvider } from '@chakra-ui/react';
import { system } from '../../customTheme';

export function Provider({ children }: PropsWithChildren) {
  return <ChakraProvider value={system}>{children}</ChakraProvider>;
}
